export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/next.f91f89f4.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};